/**
 * #489 (item 5) — tela de CONCLUSÃO do import (Fase 3 «concluído»),
 * extraída de ImportMenu.tsx por responsabilidade (regra R3).
 *
 * Além das contagens de categorias/produtos do rascunho, mostra os
 * PRATOS/OPÇÕES pausados por falta de preço — números AUTORITATIVOS do
 * commit (gravados em commit_counts e expostos pela vista quando
 * `committed`), numa região `role="status"` (anunciada pelo leitor de voz)
 * que sobrevive a recarregar a página (?id=), ao contrário do toast do
 * momento do commit. Só as linhas com n > 0 aparecem; imports anteriores
 * ao #489 (contagens `null`) não mostram nada. Sem chave nova e sem link,
 * como pedido pela orientação UX.
 */
import { useI18n } from '../../lib/i18n.js'
import { Button } from '../../components/ui/index.js'
import type { MenuImportView } from '../../lib/api.js'

export function CommittedCard({
  view,
  slug,
}: {
  view: MenuImportView
  slug?: string | undefined
}) {
  const { t } = useI18n()
  const total = view.draft?.categories.reduce((s, c) => s + c.products.length, 0) ?? 0
  // #489: null = commit anterior ao #489 (sem contagens gravadas) → sem linha
  const pausedDishes = view.paused_dishes ?? 0
  const pausedOptions = view.paused_options ?? 0
  return (
    <div data-testid="import-done" className="max-w-xl mx-auto text-center py-12 space-y-4">
      <div className="text-5xl">🎉</div>
      <h1 className="text-2xl font-bold text-gray-900">{t('admin.import.done_title')}</h1>
      <p className="text-sm text-gray-500">
        {view.draft?.categories.length} {t('admin.import.categories')} · {total}{' '}
        {t('admin.import.products_count')} — {t('admin.import.done_desc')}
      </p>
      {(pausedDishes > 0 || pausedOptions > 0) && (
        <div
          role="status"
          data-testid="import-paused-counts"
          className="mx-auto max-w-md text-left text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded-xl px-4 py-3 space-y-1"
        >
          {pausedDishes > 0 && (
            <p>{t('admin.import.paused_dishes_no_price', { n: String(pausedDishes) })}</p>
          )}
          {pausedOptions > 0 && (
            <p>{t('admin.import.paused_options_no_price', { n: String(pausedOptions) })}</p>
          )}
        </div>
      )}
      <Button
        data-testid="import-open-menu"
        onClick={() => window.location.assign(`/r/${slug}/menu`)}
      >
        {t('admin.import.open_menu')}
      </Button>
    </div>
  )
}
